var usersList = (function () {

    const init = function () {
        $('#users-datatable').DataTable({
            "autoWidth": false,
            "stateSave": true,
            "responsive": true,
            "order": [],
            "columnDefs": [
                { "className": 'full-name-column', "targets": 0 },
                { "className": 'email-column desktop', "targets": 1 },
                { "className": 'phone-number-column desktop', "targets": 2 },
                { "orderable": false, "targets": 3 },
                { "className": 'actions-column desktop', "targets": 3 }
            ],
            language: {
                url: 'https://cdn.datatables.net/plug-ins/1.10.19/i18n/Ukrainian.json'
                //TODO: make it depends on current culture not on sdn call
            }
        });


        $('#users-datatable')
            .on('click', '.mdi-lock', function () {
                const id = $(this).data('user-id');
                sendBlockRequest(id);
            });

        $('#users-datatable')
            .on('click', '.mdi-lock-open-outline', function () {
                const id = $(this).data('user-id');
                sendUnblockRequest(id);
            });

        $('#users-datatable')
            .on('click', '.mdi-lock-reset', function () {
                const id = $(this).data('user-id');
                sendChangePasswordInvitation(id);
            });

        $('#users-datatable')
            .on('click', '.mdi-delete', function () {
                const id = $(this).data('user-id');
                const email = $(this).data('user-email');
                $('#user-email-to-delete').text(email);
                $('#delete-user-button').attr('data-user-id', id);
            });

        $('#delete-user-button').on('click',
            function () {
                const userIdToDelete = $(this).data('user-id');
                $.ajax({
                        url: `/UserManagement/Delete/${userIdToDelete}`,
                        method: 'DELETE',
                        contentType: 'application/json'
                    })
                    .done(function (data) {
                        $('#delete-modal').modal('hide');
                        $.showNotification(data.header, data.message, data.succeed);
                    });
            });

        function sendChangePasswordInvitation(id) {
            $.ajax({
                    url: `/UserManagement/SendChangePasswordInvitation/${id}`,
                    method: 'PUT',
                    contentType: 'application/json'
                })
                .done(function (data) {
                    $.showNotification(data.header, data.message, data.succeed);
                });
        }

        function sendBlockRequest(id) {
            $.ajax({
                    url: `/UserManagement/Block/${id}`,
                    method: 'PUT',
                    contentType: 'application/json'
                })
                .done(function (data) {
                    $.showNotification(data.header, data.message, data.succeed);
                });
        }

        function sendUnblockRequest(id) {
            $.ajax({
                    url: `/UserManagement/Unblock/${id}`,
                    method: 'PUT',
                    contentType: 'application/json'
                })
                .done(function (data) {
                    $.showNotification(data.header, data.message, data.succeed);
                });
        }
    };

    return {
        init: init
    };

})();
